import OpenIcon from './OpenIcon'

export default OpenIcon
